import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { List, OrderedMap, Map } from "immutable";
import DataSyncForm from "./forms/data-sync-form";
import CompanyLosService from "./services/company-los-services";
import { fetchDataSyncRequest } from "./actions";
import { STATE_STATUS } from "../../constants";
import { Spin, Row, Col, Button, Tabs, Modal, List as AntList, message } from "antd";
import "styles/ledger-documents.css";
export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();

const { TabPane } = Tabs;

const DOC_TYPE_TABS = new OrderedMap({
    "Risk Review Sheet": 1,
    "Visibility Sheet": 2,
    "Welcome PDF": 3
});

class CompanyDataSyncDisplay extends React.Component {

    state = {
        casesList: new List([]),
        master_erps: [],
        values: new OrderedMap({}),
        loading: false,
        initialLoading: true,
        docModal: false,
        documentsList: new Map({}),
        loadingDocList: false,
        selectedTab: 1
    }
    formRef = React.createRef();

    componentDidMount() {
        CompanyLosService.getERPSoftware().then(({ data }) => {
            this.setState({
                master_erps: [...data, { name: "Other", is_sync_possible: false, key: "other" }]
            });
            CompanyLosService.getRequestSyncData(this.props.companyId).then((response) => {
                this.setState({
                    values: new OrderedMap({
                        "erp_software": data.find(_ =>
                            _.id === response.data.erp_software
                        )
                    }),
                    initialLoading: false
                });
            });
        });
    }

    componentDidUpdate() {
        if (this.props.dataSyncRequest === STATE_STATUS.FETCHED && this.state.loading) {
            this.formRef.current.resetFields();
            this.setState({
                loading: false,
                values: new OrderedMap({ erp_software: this.state.values.get("erp_software") })
            });
        }
        if (this.props.dataSyncRequest === STATE_STATUS.FETCH_FAILED && this.state.loading) {
            let error = this.props.dataSyncRequestErrorMsg;
            message.error({
                content: <a href={BASE_URL + "/company/ledger_mapping_sample"}>{error.field_error && error?.field_error.length && error?.field_error[0] || error[Object.keys(error)]  && error[Object.keys(error)][0] || "Please enter correct data"}</a>
            });
            this.setState({
                loading: false,
                values: new OrderedMap({ erp_software: this.state.values.get("erp_software") })
            });
        }
    }

    callAction = (values, type) => {
        this.props.fetchDataSyncRequest(this.props.companyId, values, type);
    }

    onSubmit = (values) => {
        this.setState({
            values: new OrderedMap(values),
            loading: true
        });
        if (!values.erp_software.is_sync_possible) {
            let data = {
                files: values.files,
                mapping: values.mapping,
                erp_software: values.erp_software.id,
                request_type: 2,
                erp_name: values.erp_name,
            };
            this.callAction(data, 2);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 2
        ) {
            let data = {
                erp_software: values.erp_software.id,
                request_type: values.request_type.id,
                files: values.files,
                mapping: values.mapping,
            };
            this.callAction(data, 2);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 1 &&
            values.contact_person &&
            values.contact_person.id
        ) {
            let data = {
                erp_software: values.erp_software.id,
                request_type: values.request_type.id,
                contact_person: values.contact_person.id,
                scheduled_at: new Date(
                    `${values.date.format("YYYY-MM-DD")} ${values.time.format("HH:mm")}`
                )
            };
            this.callAction(data, 1);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 1 &&
            !values.contact_person &&
            values.first_name &&
            values.last_name &&
            values.phone &&
            values.designation
        ) {
            let data = {
                erp_software: values.erp_software.id,
                scheduled_at: new Date(
                    `${values.date.format("YYYY-MM-DD")} ${values.time.format("HH:mm")}`
                ),
                first_name: values.first_name,
                last_name: values.last_name,
                phone: values.phone,
                designation: values.designation.id,
                request_type: values.request_type.id
            };
            this.callAction(data, "CREATE_ASSOCIATE");
        } else {
            return;
        }
    }

    onCaseAction = (action, caseId) => {
        this.listener(caseId, action);
    }
    registerListener = (listener) => {
        this.listener = listener;
    }

    toggleDocumentModal = () => {
        this.setState({
            docModal: !this.state.docModal,
            selectedTab: "1"
        }, () => {
            if(this.state.docModal) {
                this.onChangeDocTab("1");
            }
        });
    }

    onChangeDocTab = (type) => {
        this.setState({
            loadingDocList: true,
            selectedTab: type
        }, () => {
            CompanyLosService.downloadErpRequest(this.props.companyId, type).then(_ => {
                this.setState({
                    loadingDocList: false,
                    documentsList: this.state.documentsList.set(String(type), _.data)
                });
            }).catch(() => {
                this.setState({
                    loadingDocList: false,
                    documentsList: this.state.documentsList.set(String(type), [])
                });
            });
        });
    }

    getTabContent = () => {
        if(this.state.loadingDocList) {
            return (
                <div className={"d-flex flex-row justify-content-center"}>
                    <Spin />
                </div>
            );
        }
        return (
            <AntList
                dataSource={this.state.documentsList.get(String(this.state.selectedTab))}
                layout={"vertical"}
                renderItem={item => {
                    return (
                        <AntList.Item key={item.id}>
                            <div className="d-flex justify-content-space-between w-100">
                                <div>{item.document_name}</div>
                                <a href={item.file} target="_blank" rel="noopener noreferrer" download>{"Download"}</a>
                            </div>
                        </AntList.Item>
                    );
                }}
            >

            </AntList>
        );
    }


    render() {
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.docModal}
                    width={800}
                    className={"document-modal"}
                    closable={true}
                    destroyOnClose={true}
                    footer={null}
                    onCancel={this.toggleDocumentModal}
                >
                    <Tabs defaultKey={"1"} onChange={this.onChangeDocTab}>
                        {DOC_TYPE_TABS.map((_, k) => (
                            <TabPane key={_} tab={k}>
                                {this.getTabContent()}
                            </TabPane>
                        )).toList().toArray()}
                    </Tabs>
                </Modal>
                <Row className={"pt-10"} style={{
                    width: "86%"
                }}>
                    <Col span={24} className={"d-flex justify-content-flex-end"}>
                        <Button type={"link"} onClick={this.toggleDocumentModal}>{"Download Documents"}</Button>
                    </Col>
                </Row>
                {
                    this.state.initialLoading ?
                        <div className={"d-flex flex-row justify-content-center"}>
                            <Spin />
                        </div>
                        :
                        <DataSyncForm
                            ref={this.formRef}
                            loading={this.state.loading}
                            values={this.state.values}
                            onSubmit={this.onSubmit}
                            associates={this.props.associates}
                            master_erps={this.state.master_erps}
                        />
                }
            </React.Fragment>);

    }
}

const mapStateToProps = (state, props) => {
    let associates = state.companyLosProfiles.getIn(["profiles", props.companyId, "data", "associates"]);
    if(associates && associates.length >= 0){
        associates = new Map({});
    }
    return ({
        dataSyncRequest: state.companyLosProfiles.getIn(["dataSyncRequest", "status"]) || STATE_STATUS.UNFECTHED,
        dataSyncRequestErrorMsg: state.companyLosProfiles.getIn(["dataSyncRequest", "errorMsg"]) || "Please enter correct data",
        gstin: state.companyLosProfiles.getIn(["profiles", props.companyId, "data", "gstin"]),
        associates: associates.toList().toArray() || []
    });
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchDataSyncRequest
}, dispatch);


CompanyDataSyncDisplay.propTypes = {
    cases: PropTypes.object,
    companyId: PropTypes.number,
    gstin: PropTypes.string,
    updateCaseType: PropTypes.func,
    associates: PropTypes.array,
    fetchDataSyncRequest: PropTypes.func,
    dataSyncRequest: PropTypes.string
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyDataSyncDisplay);